import { Box } from '@mui/material';
import { RiDeleteBinLine } from '@remixicon/react';
import { useState } from 'react';
import ConfirmModal, { ConfirmModalLabelProps } from 'src/components/containers/modals/ConfirmModal';
import { AgButton } from 'src/components/ui';
import Hint from '../Hint';

export type DeleteButtonProps = {
  handleConfirm: () => void;
  variant?: 'icon' | 'button';
  size?: 'small' | 'medium' | 'large';
  hint?: string;
  disabled?: boolean;
  label?: string;
  icon?: React.ReactNode;
  'data-testid'?: string;
  confirmTestId?: string;
} & ConfirmModalLabelProps;

export default function DeleteButton({
  title,
  prompt,
  handleConfirm,
  variant = 'icon',
  size,
  hint = 'Delete',
  disabled = false,
  label,
  icon = <RiDeleteBinLine size={16} />,
  'data-testid': dataTestId,
  confirmTestId,
}: DeleteButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {variant === 'icon' ? (
        <Hint title={hint}>
          <Box sx={{ display: 'inline-block' }}>
            <AgButton
              variant="white"
              onPress={() => {
                setOpen(true);
              }}
              isDisabled={disabled}
              data-testid={dataTestId}
            >
              {icon}
            </AgButton>
          </Box>
        </Hint>
      ) : (
        <AgButton
          variant="destructive-white"
          size={size === 'large' ? 'lg' : size === 'small' ? 'sm' : 'md'}
          onPress={() => {
            setOpen(true);
          }}
          isDisabled={disabled}
          data-testid={dataTestId}
        >
          {label || 'Delete'}
        </AgButton>
      )}
      <ConfirmModal
        title={title}
        prompt={prompt}
        handleClose={() => {
          setOpen(false);
        }}
        handleConfirm={async () => {
          await handleConfirm();

          setOpen(false);
        }}
        open={open}
        confirmTestId={confirmTestId}
      />
    </>
  );
}
